import { COLOMBO_BORDER_RADIUS, COLOMBO_BOX_SHADOW, COLOMBO_COLORS, COLOMBO_FONTS, COLOMBO_LAYOUT, COLOMBO_SPACING, } from './colomboThemeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const colomboThemeConf = {
    color: {
        primary: {
            lightest: COLOMBO_COLORS.primary.lightest,
            light: COLOMBO_COLORS.primary.light,
            main: COLOMBO_COLORS.primary.main,
            dark: COLOMBO_COLORS.primary.dark,
            darkest: COLOMBO_COLORS.primary.darkest,
        },
        brand: {
            lightest: COLOMBO_COLORS.brand.lightest,
            light: COLOMBO_COLORS.brand.light,
            main: COLOMBO_COLORS.brand.main,
            dark: COLOMBO_COLORS.brand.dark,
            darkest: COLOMBO_COLORS.brand.darkest,
        },
        success: {
            light: COLOMBO_COLORS.success.light,
            main: COLOMBO_COLORS.success.main,
            dark: COLOMBO_COLORS.success.dark,
        },
        error: {
            lightest: COLOMBO_COLORS.error.lightest,
            light: COLOMBO_COLORS.error.light,
            main: COLOMBO_COLORS.error.main,
            dark: COLOMBO_COLORS.error.dark,
        },
        warning: {
            lightest: COLOMBO_COLORS.warning.lightest,
            light: COLOMBO_COLORS.warning.light,
            main: COLOMBO_COLORS.warning.main,
        },
        grey: {
            lightest: COLOMBO_COLORS.grey.lightest,
            light: COLOMBO_COLORS.grey.light,
            default: COLOMBO_COLORS.grey.default,
            dark: COLOMBO_COLORS.grey.dark,
            darkest: COLOMBO_COLORS.grey.darkest,
        },
        input: {
            placeholder: COLOMBO_COLORS.grey.default,
            border: COLOMBO_COLORS.grey.default,
        },
        background: {
            body: COLOMBO_COLORS.background.body,
            light: COLOMBO_COLORS.background.light,
            dark: COLOMBO_COLORS.background.dark,
        },
        font: {
            dark: COLOMBO_COLORS.font.dark,
            light: COLOMBO_COLORS.font.light,
        },
        common: {
            contentHover: COLOMBO_COLORS.common.contentHover,
        },
    },
    font: {
        family: COLOMBO_FONTS.family,
        size: {
            small: COLOMBO_FONTS.size.small,
            mediumSmall: COLOMBO_FONTS.size.mediumSmall,
            medium: COLOMBO_FONTS.size.medium,
            mediumBig: COLOMBO_FONTS.size.mediumBig,
            big: COLOMBO_FONTS.size.big,
            caption: COLOMBO_FONTS.size.caption,
            title: COLOMBO_FONTS.size.title,
            heading: COLOMBO_FONTS.size.heading,
        },
        lineHeight: {
            small: COLOMBO_FONTS.lineHeight.small,
            mediumSmall: COLOMBO_FONTS.lineHeight.mediumSmall,
            medium: COLOMBO_FONTS.lineHeight.medium,
            mediumBig: COLOMBO_FONTS.lineHeight.mediumBig,
            big: COLOMBO_FONTS.lineHeight.big,
        },
        weight: {
            light: COLOMBO_FONTS.weight.light,
            normal: COLOMBO_FONTS.weight.normal,
            bold: COLOMBO_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: COLOMBO_BORDER_RADIUS.low,
            default: COLOMBO_BORDER_RADIUS.default,
            high: COLOMBO_BORDER_RADIUS.high,
            onlyTop: COLOMBO_BORDER_RADIUS.onlyTop,
            onlyRight: COLOMBO_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: COLOMBO_BOX_SHADOW.light,
            default: COLOMBO_BOX_SHADOW.default,
            dark: COLOMBO_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: COLOMBO_SPACING.layout.fullWidth,
            partialWidth: COLOMBO_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: COLOMBO_SPACING.margin.smallest,
            small: COLOMBO_SPACING.margin.small,
            default: COLOMBO_SPACING.margin.default,
            large: COLOMBO_SPACING.margin.large,
            largest: COLOMBO_SPACING.margin.largest,
            horizontalDefault: COLOMBO_SPACING.margin.horizontalDefault,
            verticalDefault: COLOMBO_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: COLOMBO_SPACING.padding.smallest,
            small: COLOMBO_SPACING.padding.small,
            default: COLOMBO_SPACING.padding.default,
            large: COLOMBO_SPACING.padding.large,
            largest: COLOMBO_SPACING.padding.largest,
            horizontalDefault: COLOMBO_SPACING.padding.horizontalDefault,
            verticalDefault: COLOMBO_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: COLOMBO_LAYOUT.width.full,
            partial: COLOMBO_LAYOUT.width.partial,
        },
        sidebar: {
            full: COLOMBO_LAYOUT.sidebar.full,
        },
        header: {
            topBar: COLOMBO_LAYOUT.header.topBar,
            menu: COLOMBO_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: COLOMBO_COLORS.brand.main,
                color: COLOMBO_COLORS.font.light,
            },
            headerSecondary: {
                background: COLOMBO_COLORS.brand.main,
                color: COLOMBO_COLORS.font.light,
            },
            th: {
                background: COLOMBO_COLORS.background.light,
                color: COLOMBO_COLORS.font.dark,
            },
            row: {
                hover: COLOMBO_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: COLOMBO_COLORS.brand.main,
                hover: COLOMBO_COLORS.brand.light,
            },
        },
        header: {
            colors: {
                background: COLOMBO_COLORS.background.light,
                text: COLOMBO_COLORS.brand.main,
                menuIcon: COLOMBO_COLORS.brand.main,
            },
        },
        menu: {
            colors: {
                background: COLOMBO_COLORS.background.light,
                text: COLOMBO_COLORS.font.dark,
                selected: COLOMBO_COLORS.brand.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: COLOMBO_COLORS.primary.light,
                headerText: COLOMBO_COLORS.font.dark,
                buttonBackground: COLOMBO_COLORS.background.light,
                buttonText: COLOMBO_COLORS.font.dark,
                buttonBackgroundHover: COLOMBO_COLORS.primary.main,
                triggerBackground: COLOMBO_COLORS.background.light,
                triggerText: COLOMBO_COLORS.brand.main,
                userIconBackground: COLOMBO_COLORS.primary.darkest,
                userIconText: COLOMBO_COLORS.font.light,
            },
        },
        tabs: {
            indicator: COLOMBO_COLORS.background.light,
            background: COLOMBO_COLORS.brand.main,
            color: COLOMBO_COLORS.font.light,
        },
        listItem: {
            backgroundHover: COLOMBO_COLORS.background.light,
            backgroundSelected: COLOMBO_COLORS.primary.main,
            textHover: COLOMBO_COLORS.font.dark,
            textSelected: COLOMBO_COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: COLOMBO_COLORS.brand.main,
                border: COLOMBO_COLORS.brand.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: COLOMBO_COLORS.background.light,
                text: COLOMBO_COLORS.font.dark,
            },
            arrow: {
                background: COLOMBO_COLORS.background.light,
            },
            rule: {
                iconSuccess: COLOMBO_COLORS.success.main,
                iconError: COLOMBO_COLORS.error.main,
                text: COLOMBO_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: COLOMBO_COLORS.grey.lightest,
            backgroundHover: COLOMBO_COLORS.grey.light,
            text: COLOMBO_COLORS.font.dark,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: COLOMBO_COLORS.primary.light,
                main: COLOMBO_COLORS.primary.main,
                dark: COLOMBO_COLORS.primary.dark,
            },
            secondary: {
                light: COLOMBO_COLORS.brand.light,
                main: COLOMBO_COLORS.brand.main,
                dark: COLOMBO_COLORS.brand.dark,
            },
            text: {
                primary: COLOMBO_COLORS.font.dark,
                secondary: COLOMBO_COLORS.font.light,
            },
        },
        typography: {
            fontFamily: COLOMBO_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: COLOMBO_COLORS.font.dark,
                    fontSize: COLOMBO_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: COLOMBO_COLORS.grey.light,
                    '&$disabled': {
                        color: COLOMBO_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: COLOMBO_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: COLOMBO_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: COLOMBO_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${COLOMBO_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: COLOMBO_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: COLOMBO_COLORS.font.light,
                        fontSize: COLOMBO_FONTS.size.mediumSmall,
                        fontWeight: COLOMBO_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${COLOMBO_COLORS.primary.main} !important`,
                },
                active: {
                    color: `${COLOMBO_COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: COLOMBO_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: COLOMBO_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const colomboTheme = createMyTheme(colomboThemeConf);
//# sourceMappingURL=colomboTheme.js.map